// extracted by mini-css-extract-plugin
export default {"Link":"LeftLinks_Link__4L-pp","PageSelected":"LeftLinks_PageSelected__8uLBq","Highlight":"LeftLinks_Highlight__2rQOO"};